import * as d3 from "d3";

export function drawSurface(target, width, height, isMobile) {
  const surfaceBox = {
    height: 1750,
    width: 1308,
    x: 0,
    y: 0,
  };

  target
    .append("rect")
    .attr("width", surfaceBox.width)
    .attr("height", surfaceBox.height)
    .style("fill", "transparent");

  target
    .append("rect")
    .attr("width", surfaceBox.width + 2)
    .attr("height", surfaceBox.height + 2)
    .attr("transform", "translate(0,0)")
    .style("fill", "transparent");

  const colonyX = Math.floor(surfaceBox.width / 1.5);
  const colonyY = Math.floor(surfaceBox.height / 1.5);

  target
    .append("rect")
    .attr("id", "colony0")
    .attr("width", 10)
    .attr("height", 10)
    .style("fill", "#bfd0cd")
    .attr("x", colonyX)
    .attr("y", colonyY);

  const y = isMobile ? 0 : 0;

  d3.select("#surface").attr("transform", "translate(0," + y + ") scale(1,1)");
}



// WEBPACK FOOTER //
// ./src/components/portfolio/drawSurface.js